import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ps-recipe-card" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_4 = { class: "details" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = {
  key: 0,
  class: "tags"
}
const _hoisted_7 = {
  key: 1,
  class: "description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_recipe_metadata = _resolveComponent("recipe-metadata")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: `/recipes/${_ctx.postId}`,
      class: "image"
    }, {
      default: _withCtx(() => [
        (_ctx.pictureUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.pictureUrl,
              alt: _ctx.title
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
              _createElementVNode("span", null, "No Image", -1)
            ])))
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h2", null, [
        _createVNode(_component_router_link, {
          to: `/recipes/${_ctx.postId}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createTextVNode("by ")),
        _createElementVNode("b", null, _toDisplayString(_ctx.author), 1),
        _cache[2] || (_cache[2] = _createTextVNode(" - ")),
        _createElementVNode("span", null, _toDisplayString(_ctx.localeDateString), 1)
      ]),
      (_ctx.recipeTags && _ctx.recipeTags.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recipeTags, (tag) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "tag",
                key: tag
              }, _toDisplayString(tag), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.trimmedDescription), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_recipe_metadata, {
        prepTime: _ctx.prepTime,
        cookTime: _ctx.cookTime,
        servings: _ctx.servings,
        compact: ""
      }, null, 8, ["prepTime", "cookTime", "servings"])
    ])
  ]))
}